import { takeLatest, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";
import history from "../../../services/history";
import { getPath, setSessionStorageKey, isCepValid } from "../../../utils";

import HttpService from "../../../services/HttpService";

import {
	changeLoading,
	selectedPlanSuccess,
	selectedResearchSuccess,
	validAddressUserSuccess,
	validAddressUserRequest,
	onGetBillingPlansSuccess,
	cleanPlanSuccess,
	changeCdRecurrenceSuccess,
	onGetPlanResearchs,
	onGetResearchByPlanSuccess,
	onGetBillingPlansByCDSuccess,
	onGetPaymentModeSuccess,
	setCdPromotional,
	responseMicroServiceFluxPromo,
	responsePlanFluxPromo,
	setFluxPromotional,
} from "./actions";

// import {
//   changeInstallmentOptionSelectedSuccess,
//   changeInstallmentOptionSuccess
// } from '../../../../old/store/modules/creditCard/actions';

export function* selectedPlan({ payload }) {
	try {
		const { plan, redirectToResearch, id_research, cd_promotional } = payload;

		yield put(selectedPlanSuccess(plan));
		yield put(changeLoading(false));
		yield put(onGetPlanResearchs(plan, redirectToResearch, id_research, cd_promotional));
	} catch (err) {
		toast.error("Não foi possível selecionar o plano.");
	}
}

export function* selectedResearch({ payload }) {
	try {
		const { research } = payload;
		yield put(selectedResearchSuccess(research));
		yield put(changeLoading(false));
		setSessionStorageKey("RESEARCHSELECTED", research);

		if (
			Object.keys(sessionStorage).indexOf("CLIENT_AUTH") !== -1 &&
			Boolean(JSON.parse(sessionStorage.CLIENT_AUTH))
		) {
			window.location.href = getPath("/onboarding/carrinho/plano");
			return;
		}

		history.push("/onboard/welcome-register");
	} catch (err) {
		toast.error("Não foi possível selecionar o research.");
	}
}

export function* selectedPlanById({ payload }) {
	try {
		const { id_plan } = payload;
		const response = yield HttpService.getBillingPlanById(Number(id_plan));
		if (!response.success) {
			throw response;
		}

		const plan = response.result;
		yield put(selectedPlanSuccess(plan));
	} catch (err) {
		console.error(err);
	}
}

export function* validAddress() {
	try {
		const response = yield HttpService.getAddressByIdInvestor();
		var isAddressValid = false;
		if (response.success) {
			const { result } = response;
			if (result.length > 0) {
				const { id_country, zip, address_number } = result[0];
				const validCEP = id_country === 1 ? isCepValid(zip) : true;
				isAddressValid = validCEP && !isNaN(address_number);
				setSessionStorageKey("ISADDRESSVALID", isAddressValid);
			}
		}

		yield put(validAddressUserSuccess(isAddressValid));
		if (isAddressValid) {
			setSessionStorageKey("isAddressValid", isAddressValid);
			// history.push("/onboard/confirme-pagamento");
		}
	} catch (err) {
		console.error(err);
		toast.error("Não foi possível validar o cadastro de endereço do usuário.");
	}
}

export function* onUpdateAddress({ payload }) {
	try {
		const { address } = payload;
		const response = yield HttpService.updateAddress(address);
		if (!response.success) {
			throw Error("Não foi possível atualizar o endereço.");
		}

		yield put(validAddressUserRequest());
	} catch (err) {
		toast.error("Não foi possível atualizar o endereço.");
	}
}

export function* onGetBillingPlans({ payload }) {
	try {
		const { cd_recurrence, cd_promotional } = payload;
		const response = yield HttpService.getBillingPlans({ cd_recurrence, cd_promotional });
		if (!response.success) {
			let message = "Não foi possível carregar os planos cadastrados.";
			if (["INVALID_PROMOTION"].includes(response.code)) message = response.message;

			throw message;
		}
		yield put(onGetBillingPlansSuccess(response.result));
		yield put(setCdPromotional(cd_promotional));

		if (cd_promotional) {
			yield put(responsePlanFluxPromo(response.result));
			yield put(setFluxPromotional(Boolean(response.result)));
			localStorage.setItem("CACHEDPLAN", JSON.stringify(response.result));
			localStorage.setItem("flow-checkout", "CHECKOUT");
		}

		if (!window.location.pathname.includes("promo")) yield put(changeLoading(false));
	} catch (err) {
		yield put(changeLoading(false));
		toast.error(err);
	}
}

export function* cleanPlan({ payload }) {
	try {
		yield put(cleanPlanSuccess());
		window.location.href = getPath("/onboarding/planos");
	} catch (err) {
		toast.error("Não foi possível pegar os planos cadastrados.");
	}
}

export function* changeCdRecurrence({ payload }) {
	try {
		const { cd_recurrence } = payload;
		yield put(changeCdRecurrenceSuccess(cd_recurrence));
	} catch (err) {
		toast.error("Ocorreu um erro ao buscar dados do plano selecionado.");
	}
}

export function* getLastActivePlanStatus() {
	try {
		const response = yield HttpService.getLastActivePlanStatus();
		if (response.success) {
			yield put(selectedPlanSuccess(response.result));
			yield put(changeCdRecurrenceSuccess(response.result.cd_recurrence));
		} else {
			throw response;
		}
	} catch (err) {
		toast.error("Ocorreu um erro ao buscar dados do plano");
	}
}

export function* getPlanResearchs({ payload }) {
	try {
		const { plan, redirectToResearch, cd_promotional } = payload;
		const response = yield HttpService.getResearchByPlan(plan.id_plan, cd_promotional);
		if (!response.success) {
			throw Error("Não foi possível carregar os researchs cadastrados.");
		}

		let result = {};

		result[plan.title] = response.result;

		setSessionStorageKey("LISTRESEARCH", result);
		yield put(onGetResearchByPlanSuccess(result, plan.title));

		if (result.length) {
			const research = response.result[0];
			if (research) {
				yield put(selectedResearchSuccess(research));
				setSessionStorageKey("RESEARCHSELECTED", research);
			}
		}

		if (response.result.length > 0 && redirectToResearch) {
			history.push("/onboard/researches/" + plan.title.toLowerCase());
		} else {
			if (
				Object.keys(sessionStorage).indexOf("CLIENT_AUTH") !== -1 &&
				Boolean(JSON.parse(sessionStorage.CLIENT_AUTH))
			) {
				window.location.href = getPath("/onboarding/carrinho/plano");
				return;
			}

			if (
				Object.keys(localStorage).indexOf("CACHEDPLAN") !== -1 &&
				Boolean(JSON.parse(localStorage.CACHEDPLAN))
			) {
				return;
			}

			history.push("/onboard/welcome-register");
		}
	} catch (err) {
		toast.error("Não foi possível pegar os planos cadastrados.");
	}
}

export function* getPlanByCode({ payload }) {
	try {
		yield put(changeLoading(true));
		const { cd_plan } = payload;
		const response = yield HttpService.getPlanByCode(cd_plan);
		if (!response.success) {
			throw Error("Não foi possível encontrar plano.");
		} else {
			const plan = response.result;
			setSessionStorageKey("PLANSELECTED", plan);
			yield put(onGetBillingPlansByCDSuccess(plan));
		}
	} catch (error) {
		yield put(changeLoading(false));
		console.error(error);
	}
}

export function* getProductByCode({ payload }) {
	try {
		yield put(changeLoading(true));
		const { cd_plan } = payload;
		const response = yield HttpService.getProductByCode(cd_plan);
		if (!response.success) {
			throw Error("Não foi possível encontrar plano.");
		} else {
			let plan = response.result;
			if (!plan.email_confirmation_type) plan.email_confirmation_type = 2;
			setSessionStorageKey("PLANSELECTED", plan);
			yield put(onGetBillingPlansByCDSuccess(plan));

			// if (!plan.is_free && plan.parcels.length) {
			//   const installmentOptions = plan.parcels.map(({ qtty, value, ...rest }) => ({
			//     label: `${qtty}x de ${formattedPrice(value)} ${!!plan.vl_interest_fee ? `(Com juros de ${formattedPercentage(plan.vl_interest_fee)} ao mês)` : "(Sem Juros)"}`,
			//     qtty,
			//     value,
			//     ...rest
			//   }))
			//   const [installmentSelected] = installmentOptions;

			//   yield put(changeInstallmentOptionSelectedSuccess(installmentSelected));
			//   yield put(changeInstallmentOptionSuccess(installmentOptions));
			// }
		}
	} catch (error) {
		yield put(changeLoading(false));
		console.error(error);
	}
}

export function* getPaymentMode({ payload }) {
	try {
		yield put(changeLoading(true));
		const { id_product } = payload;
		const response = yield HttpService.getPaymentMode(id_product);
		if (!response.success) {
			throw Error("Não foi possível encontrar meio de pagamento.");
		} else {
			const payment_mode = response.result.filter((item) => item.cd_payment !== "CREDIT");
			yield put(onGetPaymentModeSuccess(payment_mode));
		}
	} catch (error) {
		yield put(changeLoading(false));
		console.error(error);
	}
}

export function* callMicroServiceDetailByCdPromotion({ payload }) {
	try {
		yield put(changeLoading(true));

		const { cdPromotional } = payload;
		const resp = yield HttpService.getMicroServiceDetailByCdPromotion(cdPromotional);

		if (!resp.success) throw resp;

		yield put(responseMicroServiceFluxPromo(resp.result));
		yield put(setFluxPromotional(Boolean(resp.result)));
		localStorage.setItem("flow-checkout", "CHECKOUT");
	} catch (error) {
		yield put(setFluxPromotional(false));

		console.error("[ERROR - getMicroServiceDetailByCdPromotion] ", error);
		toast.error(error.message);
		history.push("/onboard/login");
	}
}

export function* callPlanDetailById({ payload }) {
	try {
		yield put(changeLoading(true));

		const { cdPromotional } = payload;
		const resp = yield HttpService.getPlanDetailByCdPromotional(cdPromotional);

		if (!resp.success) throw resp;

		yield put(responsePlanFluxPromo(resp.result));
		yield put(setFluxPromotional(Boolean(resp.result)));
		localStorage.setItem("CACHEDPLAN", JSON.stringify(resp.result));
	} catch (error) {
		yield put(setFluxPromotional(false));

		console.error("[ERROR - getPlanDetailByCdPromotional] ", error);
		toast.error(error.message);
		history.push("/onboard/login");
	}
}

// export function* getInfoElevenPlanInvestor(){
//   try {
//     yield put(changeLoading(true));
//     const response = yield HttpService.getInfoElevenPlanInvestor();
//     if (!response.success) {
//       throw 'Não foi possível pegar as informações do investidor.';
//     }else{

//       yield put(infoElevenInvestorData(response.result));
//     }
//   } catch (error) {
//     yield put(changeLoading(false));
//     console.error(error)

//   }
// }

export default all([
	takeLatest("@billingPlan/ON_GET_BILLING_PLAN_REQUEST", onGetBillingPlans),
	takeLatest("@billingPlan/ON_UPDATE_ADDRESS_REQUEST", onUpdateAddress),
	takeLatest("@billingPlan/SELECTED_PLAN_REQUEST", selectedPlan),
	takeLatest("@billingPlan/SELECTED_RESEARCH_REQUEST", selectedResearch),
	takeLatest("@billingPlan/SELECTED_PLAN_BY_ID_REQUEST", selectedPlanById),
	takeLatest("@billingPlan/VALID_ADDRESS_USER_REQUEST", validAddress),
	takeLatest("@billingPlan/CLEAN_PLAN_REQUEST", cleanPlan),
	takeLatest("@billingPlan/CHANGE_CD_RECURRENCE_REQUEST", changeCdRecurrence),
	takeLatest("@billingPlan/GET_ACTIVE_PLAN_STATUS", getLastActivePlanStatus),
	takeLatest("@billingPlan/ON_GET_PLAN_RESEARCHS", getPlanResearchs),
	takeLatest("@billingPlan/ON_GET_BILLING_PLAN_BY_CD_REQUEST", getPlanByCode),
	takeLatest("@billingPlan/ON_GET_PRODUCT_BY_CD_REQUEST", getProductByCode),
	takeLatest("@billingPlan/ON_GET_PAYMENT_MODE_REQUEST", getPaymentMode),
	takeLatest("@billingPlan/CALL_MICRO_SERVICE_DETAIL_BY_CD_PROMOTION", callMicroServiceDetailByCdPromotion),
	takeLatest("@billingPlan/CALL_PLAN_DETAIL_BY_ID", callPlanDetailById),
	// takeLatest('@billingPlan/ON_GET_INFO_ELEVEN_PLAN_INVESTOR_REQUEST', getInfoElevenPlanInvestor)
]);
